'use client';

import { Link } from '@skin-seoul/design-system';
import { VerticalProductCardImage } from './VerticalProductCardImage';
import ProductCardInfoName from '../components/ProductCardInfoName';
import ProductCardInfoRating from '../components/ProductCardInfoRating';
import { ProductCardInfoPrice } from '../components/ProductCardInfoPrice';
import type { ProductCardProps } from '../ProductCard.types';
import { ProductCardProvider } from '../ProductCardContext';
import React from 'react';
import { VerticalProductCardContent } from './VerticalProductCardContent';
import ProductCardAddToCart from '../components/ProductCardAddToCart';
import { extractPathname } from '@skin-seoul/utils';
export const VerticalProductCard = ({
  children,
  theme,
  onClick,
  orientation = 'vertical',
  ...componentProps
}: ProductCardProps) => {
  const {
    href,
    linkComponent,
    ...restProps
  } = componentProps;
  const normalizedHref = extractPathname(href);
  const LinkComponent = linkComponent || Link;
  return <ProductCardProvider value={{
    ...restProps,
    href,
    theme,
    orientation
  }} data-sentry-element="ProductCardProvider" data-sentry-component="VerticalProductCard" data-sentry-source-file="VerticalProductCard.tsx">
      <LinkComponent unstyled display="flex" flexDirection="column" gap={4} width="100%" cursor="pointer" minWidth={0} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();
      onClick?.(e);
    }} href={normalizedHref} {...restProps} data-sentry-element="LinkComponent" data-sentry-source-file="VerticalProductCard.tsx">
        <>{children}</>
      </LinkComponent>
    </ProductCardProvider>;
};
VerticalProductCard.Content = VerticalProductCardContent;
VerticalProductCard.Image = VerticalProductCardImage;
VerticalProductCard.AddToCart = ProductCardAddToCart;
VerticalProductCard.InfoName = ProductCardInfoName;
VerticalProductCard.InfoRating = ProductCardInfoRating;
VerticalProductCard.InfoPrice = ProductCardInfoPrice;